import {Platform} from '@ionic/angular';
import {Injectable} from '@angular/core';
import * as Loki from 'lokijs';
import * as LokiIndexedAdapter from 'lokijs/src/loki-indexed-adapter';
import {CollectionsNames} from '../../definitions/collections-names';
import {ObservablesService} from '../observables.service';


@Injectable({
    providedIn: 'root'
})
export class LokijsService {
    db: any;
    adapter: any;
    isLoaded = false;

    constructor(private platform: Platform,
                private collectionsNames: CollectionsNames,
                private observables: ObservablesService) {
    }

    async initDB() {
        await this.setupDatabase();
    }

    setupDatabase() {
        return new Promise((resolve, reject) => {

            if ((this.platform.is('android') || this.platform.is('ios'))) {
                this.adapter = new LokiIndexedAdapter();
            } else {
                this.adapter = new LokiIndexedAdapter();
            }

            let databaseName = 'lokijs';
            if (window.connectionConfig && window.connectionConfig.database) {
                databaseName = window.connectionConfig.database;
            }

            this.db = new Loki(databaseName,
                {
                    verbose: true,
                    autosave: false,
                    autosaveInterval: 5000,
                    adapter: this.adapter,
                    autoload: true,
                    autoloadCallback: () => {
                        this.isLoaded = true;
                    },
                });
            // this.databaseHasBeenLoaded();

            try {
                const interval = setInterval(() => {
                    if (this.isLoaded) {
                        console.log('autoloadCallback done');
                        clearInterval(interval);
                        this.databaseHasBeenLoaded();
                        resolve(true);
                    }
                }, 100);
            } catch (error) {
                reject(error);
            }

        });
    }

    public saveDatabase(): void {
        this.db.saveDatabase();
    }

    public databaseHasBeenLoaded(): void {

        let table = this.db.getCollection(this.collectionsNames.CONFIGURATION);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.CONFIGURATION, {unique: ['id']});
        }

        table = this.db.getCollection(this.collectionsNames.MOBILECONFIGURATION);
        if (table === null) {
            this.db.addCollection(this.collectionsNames.MOBILECONFIGURATION);
        }

        table = this.db.getCollection(this.collectionsNames.OPERATOR);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.OPERATOR, {unique: ['cod']});
        }

        table = this.db.getCollection(this.collectionsNames.OPERATORANDAPIKEY);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.OPERATORANDAPIKEY, {unique: ['cod']});
        }

        table = this.db.getCollection(this.collectionsNames.PRINTLIST);
        if (table === null) {
            this.db.addCollection(this.collectionsNames.PRINTLIST);
        }

        table = this.db.getCollection(this.collectionsNames.CONTACT);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.CONTACT, {unique: 'id', indices: ['depot', 'cust', 'phone']});
        }

        table = this.db.getCollection(this.collectionsNames.CUSTOMER);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.CUSTOMER, {unique: 'id', indices: ['depot', 'cust', 'name']});
        }

        table = this.db.getCollection(this.collectionsNames.DOCUMENTREQUESTTYPE);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.DOCUMENTREQUESTTYPE, {unique: ['id']});
        }

        table = this.db.getCollection(this.collectionsNames.DOCUMENT);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.DOCUMENT);
        }

        table = this.db.getCollection(this.collectionsNames.LIVEDETAILLINES);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.LIVEDETAILLINES, {unique: '_id'});
        }

        table = this.db.getCollection(this.collectionsNames.LIVECONTRACT);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.LIVECONTRACT, {unique: '_id'});
        }

        table = this.db.getCollection(this.collectionsNames.ENGINEER);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.ENGINEER, {unique: 'id'});
        }

        table = this.db.getCollection(this.collectionsNames.DEPOT);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.DEPOT, {unique: 'cod'});
        }

        table = this.db.getCollection(this.collectionsNames.PLANTSTATUSLIST);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.PLANTSTATUSLIST, {unique: 'nsuk'});
        }

        table = this.db.getCollection(this.collectionsNames.JOBSTATUSLIST);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.JOBSTATUSLIST, {unique: 'id'});
        }

        table = this.db.getCollection(this.collectionsNames.JOBTYPE);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.JOBTYPE, {unique: 'id'});
        }

        table = this.db.getCollection(this.collectionsNames.JOBCERTIFICATETEXT);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.JOBCERTIFICATETEXT, {unique: 'id'});
        }

        table = this.db.getCollection(this.collectionsNames.QUEUEDDOCUMENTS);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.QUEUEDDOCUMENTS, {unique: '_id'});
        }

        table = this.db.getCollection(this.collectionsNames.SITE);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.SITE, {unique: 'id', indices: ['depot', 'cust']});
        }

        table = this.db.getCollection(this.collectionsNames.EQUIPMENT);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.EQUIPMENT, {unique: 'id', indices: ['group']});
        }

        table = this.db.getCollection(this.collectionsNames.EQUIPMENTDISTINCTPDESC);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.EQUIPMENTDISTINCTPDESC, {unique: 'pdesc', indices: ['group']});
        }

        table = this.db.getCollection(this.collectionsNames.PRODUCTTYPE);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.PRODUCTTYPE, {unique: 'id', indices: ['group']});
        }

        table = this.db.getCollection(this.collectionsNames.SPARESUSEDINWS);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.SPARESUSEDINWS, {unique: 'id'});
        }

        table = this.db.getCollection(this.collectionsNames.PTSERIAL);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.PTSERIAL, {unique: 'id'});
        }

        table = this.db.getCollection(this.collectionsNames.PRICELISTDETAILS);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.PRICELISTDETAILS, {unique: 'id'});
        }

        table = this.db.getCollection(this.collectionsNames.HACCESS);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.HACCESS, {unique: 'id', indices: ['packagePdesc,pdesc']});
        }

        table = this.db.getCollection(this.collectionsNames.SACCESS);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.SACCESS, {unique: 'id', indices: ['packagePdesc,plu']});
        }

        table = this.db.getCollection(this.collectionsNames.POLICY);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.POLICY);
        }

        table = this.db.getCollection(this.collectionsNames.PRICELIST);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.PRICELIST, {unique: 'nsuk'});
        }

        table = this.db.getCollection(this.collectionsNames.METERTYPE);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.METERTYPE, {unique: 'id'});
        }

        table = this.db.getCollection(this.collectionsNames.HIREDEPT);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.HIREDEPT, {unique: 'nsuk'});
        }

        table = this.db.getCollection(this.collectionsNames.HIREDEPTGROUP);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.HIREDEPTGROUP, {unique: 'nsuk', indices: ['hireDept']});
        }

        table = this.db.getCollection(this.collectionsNames.DEPT);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.DEPT, {unique: 'nsuk', indices: ['cod']});
        }

        table = this.db.getCollection(this.collectionsNames.DEPTGROUP);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.DEPTGROUP, {unique: 'nsuk', indices: ['cod,dept']});
        }

        table = this.db.getCollection(this.collectionsNames.CUSTOMERLOCATION);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.CUSTOMERLOCATION);
        }

        table = this.db.getCollection(this.collectionsNames.PROJECT);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.PROJECT, {unique: 'nsuk'});
        }

        table = this.db.getCollection(this.collectionsNames.SERVICEJOB);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.SERVICEJOB, {unique: 'id'});
        }

        table = this.db.getCollection(this.collectionsNames.DOCSERVICEJOBTEMP);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.DOCSERVICEJOBTEMP, {unique: 'documentNumber'});
        }

        table = this.db.getCollection(this.collectionsNames.JOBTEMPLATE);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.JOBTEMPLATE, {indices: ['jobType,task,pdesc']});
        }

        table = this.db.getCollection(this.collectionsNames.MANDATORYMETERS);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.MANDATORYMETERS, {unique: 'id', indices: ['pdesc,jobType']});
        }

        table = this.db.getCollection(this.collectionsNames.TASKS);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.TASKS, {unique: 'nsuk'});
        }

        table = this.db.getCollection(this.collectionsNames.HRATES);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.HRATES, {unique: 'id', indices: ['pdesc,tender']});
        }


        table = this.db.getCollection(this.collectionsNames.RETURN);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.RETURN, {unique: 'documentNumber'});
        }

        table = this.db.getCollection(this.collectionsNames.CASHACCOUNTS);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.CASHACCOUNTS, {unique: 'cod'});
        }


        table = this.db.getCollection(this.collectionsNames.PAYMENTMETHODS);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.PAYMENTMETHODS, {unique: 'cod'});
        }


        table = this.db.getCollection(this.collectionsNames.SYSTEMCONFIGURATION);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.SYSTEMCONFIGURATION, {unique: 'num'});
        }


        table = this.db.getCollection(this.collectionsNames.ERRORLOG);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.ERRORLOG);
        }


        table = this.db.getCollection(this.collectionsNames.ACTION);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.ACTION);
        }


        table = this.db.getCollection(this.collectionsNames.QUEUEDACTION);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.QUEUEDACTION, {unique: 'id'});
        }


        table = this.db.getCollection(this.collectionsNames.ACTIONTYPE);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.ACTIONTYPE, {unique: 'id'});
        }


        table = this.db.getCollection(this.collectionsNames.ACTIONPRIORITY);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.ACTIONPRIORITY, {unique: 'id'});
        }


        table = this.db.getCollection(this.collectionsNames.SCREENPREFERENCES);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.SCREENPREFERENCES);
        }


        table = this.db.getCollection(this.collectionsNames.STOCKCOUNTS);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.STOCKCOUNTS);
        }

        table = this.db.getCollection(this.collectionsNames.PRODUCTBARCODESTOCKTAKE);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.PRODUCTBARCODESTOCKTAKE, {unique: 'barcode'});
        }

        table = this.db.getCollection(this.collectionsNames.SCANNEDBARCODES);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.SCANNEDBARCODES, {unique: 'barcode'});
        }

        table = this.db.getCollection(this.collectionsNames.BINLOCATIONS);

        if (table === null) {
            this.db.addCollection(this.collectionsNames.BINLOCATIONS, {unique: 'nsuk'});
        }

        console.log('AutoLoaded');
        console.log(this.db);
    }


    getTable(name: string, unique: string) {
        return this.db.getCollection(name);
    }

    getGenericObjs(name: string) {
    }

    getCollection(name: string) {
        return this.db.getCollection(name);
    }

    removeCollection(name: string){
        this.db.removeCollection(name);
    }

    putGenericObj(collectionName: string, genericObj: any, filter: string) {

    }

    upsert(collectionName: string, uniqueId: string, data: any) {
        const collection = this.getTable(collectionName, '');
        this.upsertfunction(collection, uniqueId, data);
    }

    private upsertfunction(collection: any, uniqueId: string, data: any) {
        let localRec: any;
        if (uniqueId === '$loki') {
            if (data[uniqueId]) {
                localRec = collection.get(data[uniqueId]);
            } else {
                localRec = null;
            }

        } else {
            localRec = collection.by(uniqueId, data[uniqueId]);
        }
        if (localRec) {
            data.$loki = localRec.$loki;
            data.meta = localRec.meta;
            return collection.update(data);
        } else {
            return collection.insert(data);
        }
    }

    async bulkUpsert(collectionName: string, uniqueId: string, dataArray: any []) {
        const collection = this.getCollection(collectionName);

        for (const d of dataArray) {
            //console.log(d);
            await this.upsertfunction(collection, uniqueId, d);
        }

    }


}
